<template>
  <div class="health-status">
    <div class="status-card">
      <div class="status-info">
        <span class="name">{{ $t('admin.health.title') }}</span>
        <p class="description">{{ isOperational ? 'API is operational' : 'API service unavailable' }}</p>
      </div>
      <span :class="['status', isOperational ? 'ok' : 'error']">
        {{ isOperational ? $t('admin.health.status.ok') : $t('admin.health.status.error') }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'health-status',
  data() {
    return {
      isOperational: false,
    };
  },
  mounted() {
    this.fetchHealthStatus();
  },
  methods: {
    async fetchHealthStatus() {
      try {
        const apiUrl = import.meta.env.VITE_APP_onBackstageAPI + 'api/health';
        const healthResponse = await fetch(apiUrl);
        if (healthResponse.ok) {
          const body = await healthResponse.json();
          this.isOperational = body?.status === 'ok';
        } else {
          this.isOperational = false;
        }
      } catch {
        this.isOperational = false;
      }
    },
  },
});
</script>

<style lang="scss">
.health-status {
  @include main-max-with;

  padding: 20px 10px 0;
  width: 100%;
  margin: 0 auto;

  .status-card {
    display: flex;
    border: 1px solid #ccc;
    background-color: var(--primary-bg-color);
    padding: 15px;
    justify-content: space-between;
    align-items: center;
    color: var(--primary-text-color);

    .name {
      font-weight: bold;
    }
    .description {
      margin: 5px 0 0;
    }
    .status {
      font-weight: bold;
      &.ok {
        color: var(--special-green-color-darker);
      }
      &.error {
        color: var(--special-red-color-darker);
      }
    }
  }
}
</style>
